export default __webpack_public_path__ + "static/media/profile2.2f11a7a8.png";